import { PlusOutlined } from '@ant-design/icons';
import {
  Button, Col, Row, Select, Space, Typography,
} from 'antd';
import SearchItemInput from 'components/ItemsInput/AddOrderItemOverlay/SearchItemInput';
import useIsMobile from 'hooks/useIsMobile';
import React from 'react';
import { INGREDIENT_FILTER_OPTIONS } from './constants';

function Toolbar({
  searchTerm,
  setSearchTerm,
  categoryFilter,
  setCategoryFilter,
  onCreate,
  loading,
  totalCount,
}) {
  const isMobile = useIsMobile();

  return (
    <Space direction="vertical" size={12} className="w-full">
      <Row align="middle" justify="space-between" gutter={[12, 12]}>
        <Col xs={24} md={16}>
          <Typography.Title level={4} style={{ margin: 0 }}>
            Ingredients library
          </Typography.Title>
          <Typography.Text type="secondary">
            The raw materials your recipes draw from.
          </Typography.Text>
        </Col>
        <Col xs={24} md={8} style={{ textAlign: 'end' }}>
          <Button
            icon={<PlusOutlined />}
            block={isMobile}
            type="primary"
            disabled={loading}
            onClick={onCreate}
          >
            Add ingredient
          </Button>
        </Col>
      </Row>

      <Row gutter={[16, 16]} className="w-full">
        <Col xs={24} md={10}>
          <SearchItemInput value={searchTerm} onChange={setSearchTerm} placeholder="Search ingredients..." />
        </Col>
        <Col xs={24} md={14}>
          <Select
            value={categoryFilter}
            options={INGREDIENT_FILTER_OPTIONS}
            onChange={setCategoryFilter}
            style={{ width: isMobile ? '100%' : 260 }}
          />
        </Col>
      </Row>

      <Typography.Text type="secondary">
        {totalCount}
        {' ingredients'}
      </Typography.Text>
    </Space>
  );
}

export default Toolbar;
